import React from 'react';
import { connect } from 'react-redux';
import appBaseUrlSelector from 'selectors/appBaseUrlSelector';
import currentUrlSelector from 'selectors/currentUrlSelector';
import EmailShare from './EmailShare';
import FacebookShare from './FacebookShare';
import TwitterShare from './TwitterShare';

const outlets = [
    { key: 'email', Component: EmailShare },
    { key: 'facebook', Component: FacebookShare },
    { key: 'twitter', Component: TwitterShare }
];

const SharePalette = (props) => (
    <div className="shareMenu">
        <span className="shareMenu__toggle icon-font-after icon-share-solid-after" />
        <ul className="shareMenu__list">
            {outlets.map((outlet) => (
                <li key={`social-share-${outlet.key}`}>
                    <outlet.Component {...props} />
                </li>
            ))}
        </ul>
    </div>
);

const mapStateToProps = (state) => ({
    appBaseUrl: appBaseUrlSelector(state),
    currentUrl: currentUrlSelector(state)
});

export default connect(mapStateToProps)(SharePalette);



// WEBPACK FOOTER //
// ./app/social/SharePalette.js